// 键盘事件处理混入
export default {
    data() {
        return {
            // ----------购买人信息弹窗---------
            buyerInfoDialogVisible: false,
            buyerInfoForm: {
                name: '',
                phone: '',
                idCard: ''
            },
            buyerInfoRules: {
                name: [
                    { required: true, message: '请输入姓名', trigger: 'blur' }
                ],
                phone: [
                    { required: true, message: '请输入手机号', trigger: 'blur' },
                    { pattern: /^1[3-9]\d{9}$/, message: '手机号格式不正确', trigger: 'blur' }
                ],
                idCard: [
                    { required: true, message: '请输入身份证号', trigger: 'blur' },
                    { validator: this.validateIdCard, trigger: 'blur' }
                ]
            },


            // ----------会员储值弹窗---------
            rechargeDialogVisible: false,
            rechargeForm: {
                psmoney: '',
                cardNo: '',
                name: '',
                storedBalance: '',
                memId: '',
            },
            // ----------会员选择弹窗---------
            memberSelectDialogVisible: false,
            memberSelectList: [], // 会员列表
            memberSelectSearch: '', // 会员搜索
            // ----------挂单相关---------
            holdOrderDialogVisible: false,
            holdOrderList: [], // 挂单列表
            holdOrderRemark: '', // 挂单备注输入
            holdOrderRemarkDialogVisible: false, // 备注输入弹窗
            selectedHoldOrderIndex: -1, // 挂单弹窗选中索引
            selectedHoldOrderDetails: [], // 选中挂单的明细数据
            selectedHoldOrderSummary: null, // 选中挂单的汇总信息
            // ----------商品选择---------
            searchKey: '',
            quickQuantity: 1,
            selectedProduct: {},
            // 订单备注
            orderRemark: '',
            batchList: [],
            selectedBatch: null,
            productSelectDialogVisible: false,//商品选择弹窗
            productSelectList: [], // 商品列表
            productSelectSearch: '', // 商品搜索
            productSearchTimer: null, // 商品搜索防抖
            salesPersonList: [], // 销售员列表
            doctorList: [], // 医师列表
            pharmacistList: [], // 药师列表
            searchTimer: null, // 搜索防抖定时器
            day: 0,
            curDate: 0,
            curTime: 0,
            timeTimer: null, // 定时器
            week: 0,
            isZero:0,
            currentTime: '', // 当前时间显示
            //---------------修改数量弹窗---------------
            quantityEditDialogVisible: false,
            //--------------- 修改单价弹窗---------------
            priceEditDialogVisible: false,
            // ------------------收款台-----------
            cashdeskList: [], // 收款台列表
            deskSelectDialogVisible: false, // 收款台选择弹窗
            deskSelected: false,
            isMemberRecharge: false, // 是否是会员充值场景
        };
    },
    mounted() {
        // 新增：如果收款台大于1，弹窗选择
        if (this.cashdeskList && this.cashdeskList.length > 1) {
            this.deskSelectDialogVisible = true;
            this.selectedDeskIndex = 0;
        }
    },
    beforeDestroy() { },
    methods: {
        //------------- 购买人信息弹窗打开时聚焦到姓名输入框 -------------
        onBuyerInfoDialogOpen() {
            this.$nextTick(() => {
                setTimeout(() => {
                    if (this.$refs.buyerNameInput) {
                        this.$refs.buyerNameInput.focus();
                    }
                }, 100);
            });
        },
        // 聚焦到下一个输入框
        focusNextInput(refName) {
            this.$nextTick(() => {
                if (this.$refs[refName]) {
                    this.$refs[refName].focus();
                }
            });
        },
        // 聚焦到上一个输入框
        focusLastInput(refName) {
            this.$nextTick(() => {
                if (this.$refs[refName]) {
                    this.$refs[refName].focus();
                }
            });
        },
        // 购买人信息弹窗：聚焦到下一个输入框或确认按钮
        focusNextBuyerInput(currentRef) {
            const inputOrder = ['buyerNameInput', 'buyerPhoneInput', 'buyerIdCardInput', 'buyerInfoConfirmButton'];
            const currentIndex = inputOrder.indexOf(currentRef);
            const nextIndex = (currentIndex + 1) % inputOrder.length;
            const nextRef = inputOrder[nextIndex];
            if (this.memberInfo.memId) {
                this.$http.fixMemberInfo({
                    memBirth: this.memberInfo.customerIdCard.slice(6, 14),
                    memId: this.memberInfo.memId,
                    memIdcard: this.memberInfo.customerIdCard,
                    memName: this.memberInfo.customerName,
                    memPhone: this.memberInfo.customerPhoneNumber
                }).then(res => {

                })
            }

            this.$nextTick(() => {
                if (this.$refs[nextRef]) {
                    if (nextRef === 'buyerInfoConfirmButton') {
                        // 聚焦到确认按钮
                        this.$refs[nextRef].$el.focus();
                    } else {
                        // 聚焦到输入框
                        this.$refs[nextRef].focus();
                    }
                }
            });
        },
        // 购买人信息弹窗：聚焦到上一个输入框或确认按钮
        focusLastBuyerInput(currentRef) {
            const inputOrder = ['buyerNameInput', 'buyerPhoneInput', 'buyerIdCardInput', 'buyerInfoConfirmButton'];
            const currentIndex = inputOrder.indexOf(currentRef);
            const lastIndex = currentIndex === 0 ? inputOrder.length - 1 : currentIndex - 1;
            const lastRef = inputOrder[lastIndex];

            this.$nextTick(() => {
                if (this.$refs[lastRef]) {
                    if (lastRef === 'buyerInfoConfirmButton') {
                        // 聚焦到确认按钮
                        this.$refs[lastRef].$el.focus();
                    } else {
                        // 聚焦到输入框
                        this.$refs[lastRef].focus();
                    }
                }
            });
        },
        // 购买人信息弹窗键盘事件处理
        handleBuyerInfoDialogKeyDown(event) {
            if (!this.buyerInfoDialogVisible) {
                return;
            }
            // 处理Tab键，只在弹窗内循环
            if (event.key === 'Tab') {
                event.preventDefault();
                event.stopPropagation();
                // 获取当前聚焦的元素
                const activeElement = document.activeElement;
                const inputOrder = ['buyerNameInput', 'buyerPhoneInput', 'buyerIdCardInput', 'buyerInfoConfirmButton'];
                // 找到当前聚焦元素对应的ref
                let currentRef = null;
                for (const ref of inputOrder) {
                    if (this.$refs[ref]) {
                        if (ref === 'buyerInfoConfirmButton') {
                            if (this.$refs[ref].$el === activeElement || this.$refs[ref].$el.contains(activeElement)) {
                                currentRef = ref;
                                break;
                            }
                        } else {
                            if (this.$refs[ref].$el === activeElement || this.$refs[ref].$el.contains(activeElement)) {
                                currentRef = ref;
                                break;
                            }
                        }
                    }
                }

                // 如果没有找到当前聚焦的元素，默认从第一个开始
                if (!currentRef) {
                    currentRef = 'buyerNameInput';
                }

                // 根据Shift+Tab决定方向
                if (event.shiftKey) {
                    // Shift+Tab，向上导航
                    this.focusLastBuyerInput(currentRef);
                } else {
                    // Tab，向下导航
                    this.focusNextBuyerInput(currentRef);
                }
                return;
            }

            // 处理ESC键
            if (event.key === 'Escape') {
                event.preventDefault();
                event.stopPropagation();
                this.buyerInfoDialogVisible = false;
                return;
            }
        },
        // 身份证号校验函数
        validateIdCard(rule, value, callback) {
            if (!value) {
                callback(new Error('请输入身份证号'));
                return;
            }

            // 身份证号长度验证
            if (value.length !== 15 && value.length !== 18) {
                callback(new Error('身份证号长度不正确'));
                return;
            }

            // 身份证号格式验证
            const reg = /(^\d{15}$)|(^\d{17}(\d|X|x)$)/;
            if (!reg.test(value)) {
                callback(new Error('身份证号格式不正确'));
                return;
            }

            // 如果是15位身份证号，简单校验
            if (value.length === 15) {
                // 15位身份证号都是数字
                if (!/^\d+$/.test(value)) {
                    callback(new Error('15位身份证号应全为数字'));
                    return;
                }
                callback();
                return;
            }

            // 18位身份证号校验
            // 1. 前17位必须是数字
            if (!/^\d{17}[\dXx]$/.test(value)) {
                callback(new Error('18位身份证号前17位必须为数字'));
                return;
            }

            // 2. 验证出生日期
            const year = parseInt(value.substring(6, 10));
            const month = parseInt(value.substring(10, 12));
            const day = parseInt(value.substring(12, 14));

            // 验证年份
            const currentYear = new Date().getFullYear();
            if (year < 1900 || year > currentYear) {
                callback(new Error('身份证号中的出生年份不合法'));
                return;
            }

            // 验证月份
            if (month < 1 || month > 12) {
                callback(new Error('身份证号中的出生月份不合法'));
                return;
            }

            // 验证日期
            const daysInMonth = [0, 31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
            // 闰年2月有29天
            if ((year % 4 === 0 && year % 100 !== 0) || year % 400 === 0) {
                daysInMonth[2] = 29;
            }

            if (day < 1 || day > daysInMonth[month]) {
                callback(new Error('身份证号中的出生日期不合法'));
                return;
            }

            // 3. 验证校验码
            // 加权因子
            const factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
            // 校验码对应值
            const parity = ['1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2'];

            let sum = 0;
            for (let i = 0; i < 17; i++) {
                sum += parseInt(value.charAt(i)) * factor[i];
            }

            const mod = sum % 11;
            const checkCode = parity[mod].toUpperCase();
            const lastChar = value.charAt(17).toUpperCase();

            if (checkCode !== lastChar) {
                callback(new Error('身份证号校验码错误'));
                return;
            }

            // 所有验证通过
            callback();
        },
        // 购买人信息弹窗确认
        onBuyerInfoConfirm() {
            this.$refs.buyerInfoFormRef.validate(valid => {
                if (!valid) return;
                if (!this.buyerInfoProduct) return;

                // 将购买人信息写入商品对象
                const productWithBuyer = {
                    ...this.buyerInfoProduct,
                    buyerName: this.buyerInfoForm.name,
                    buyerPhone: this.buyerInfoForm.phone,
                    buyerIdCard: this.buyerInfoForm.idCard
                };

                // 如果没有姓名、手机号、身份证号信息，将购买人信息反显到底部
                if (!this.memberInfo.customerName || !this.memberInfo.customerPhoneNumber || !this.memberInfo.customerIdCard) {
                    this.memberInfo.customerName = this.buyerInfoForm.name;
                    this.memberInfo.customerPhoneNumber = this.buyerInfoForm.phone;
                    this.memberInfo.customerIdCard = this.buyerInfoForm.idCard;
                }

                this.buyerInfoDialogVisible = false;
                this.buyerInfoProduct = null;
                // 继续添加到购物车
                this.addToCart(productWithBuyer);
                this.$nextTick(() => {
                    // 同步商品信息区（selectedItemIndex已在addToCart中设置）
                    this.syncSelectedItemToProductArea();
                    // 确保数量输入框显示1并聚焦
                    this.quantityChange = 1;
                    if (this.$refs.quantityInput) {
                        this.$refs.quantityInput.focus();
                        this.$refs.quantityInput.select && this.$refs.quantityInput.select();
                    }
                });
            });
        },
        onBuyerInfoDialogClose() {
            this.buyerInfoDialogVisible = false;
            this.buyerInfoProduct = null;
        },



        // ---------顶部聚焦到销售员选择框 ---------
        // 销售员选择改变事件
        onSalesPersonChange(e) {
            // 先根据选中的销售员ID找到对应的销售员名称
            const selectedSalesPerson = this.salesPersonList.find(person => person.opmId === e);
            if (selectedSalesPerson) {
                this.memberInfo.salesPersonName = selectedSalesPerson.opmName;
            }
            // 更新记录为当前的销售员ID
            this.previousSalesPerson = this.memberInfo.salesPerson;
        },

        // 销售员选择框聚焦事件
        onSalesPersonFocus(type) {
            if (type === 1) {
                this.isSalesPersonFocused = true;
                this.focusedInput = 'salesPerson';

            } else if (type === 2) {
                this.isDoctorFocused = true;
                this.focusedInput = 'doctor';

            } else if (type === 3) {
                this.isPharmacistFocused = true;
                this.focusedInput = 'pharmacist';

            }
        },
        // 销售员选择框失焦事件
        onSalesPersonBlur(type) {
            if (type === 1) {
                this.isSalesPersonFocused = false;
                this.focusedInput = '';
                console.log('销售员选择框已失焦');
            } else if (type === 2) {
                this.isDoctorFocused = false;
                this.focusedInput = '';
                console.log('开方医师选择框已失焦');
            } else if (type === 3) {
                this.isPharmacistFocused = false;
                this.focusedInput = '';
                console.log('执业药师选择框已失焦');
            }
        },
        // 输入框聚焦事件
        onInputFocus(event) {
            const target = event.target;
            console.log('聚焦事件目标:', target);

            // 检查是否是el-input或el-select
            const inputElement = target.closest('.el-input') || target.closest('.el-select');
            if (inputElement) {
                console.log('找到输入元素:', inputElement);

                if (inputElement === this.$refs.memberCardInput?.$el) {
                    this.focusedInput = 'memberCard';
                } else if (inputElement === this.$refs.customerNameInput?.$el) {
                    this.focusedInput = 'customerName';
                } else if (inputElement === this.$refs.customerPhoneInput?.$el) {
                    this.focusedInput = 'customerPhone';
                } else if (inputElement === this.$refs.doctorSelect?.$el) {
                    this.focusedInput = 'doctor';
                } else if (inputElement === this.$refs.pharmacistSelect?.$el) {

                    this.focusedInput = 'pharmacist';
                }
            }
            console.log('输入框聚焦:', this.focusedInput);
        },
        // 输入框失焦事件
        onInputBlur() {
            this.focusedInput = '';
            console.log('输入框失焦');
        },
        // 处理顶部输入框的键盘导航
        handleTopInputKeydown(event) {
            // 只处理左右箭头键
            if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') {
                return;
            }

            // 定义输入框的顺序（从左到右）
            const inputRefs = [
                'salesPersonSelect',    // 销售员
                'memberCardInput',      // 会员卡号
                'customerNameInput',    // 姓名
                // 'customerPhoneInput',   // 手机号
                'customerIdCardInput',  // 身份证号
                'doctorSelect',         // 开方医师
                'pharmacistSelect'      // 执业药师
            ];

            // 找到当前聚焦的输入框索引
            const currentIndex = inputRefs.findIndex(ref => {
                const element = this.$refs[ref];
                return element && element.$el && element.$el.contains(document.activeElement);
            });

            if (currentIndex === -1) return;

            let nextIndex;
            if (event.key === 'ArrowRight') {
                // 向右导航
                nextIndex = (currentIndex + 1) % inputRefs.length;
            } else {
                // 向左导航
                nextIndex = (currentIndex - 1 + inputRefs.length) % inputRefs.length;
            }

            // 聚焦到下一个输入框
            const nextRef = inputRefs[nextIndex];
            const nextElement = this.$refs[nextRef];

            if (nextElement) {
                event.preventDefault();
                this.$nextTick(() => {
                    nextElement.focus();
                    // 如果是输入框，选中内容
                    if (nextElement.select) {
                        nextElement.select();
                    }
                });
            }
        },
        // ----------会员储值弹窗---------
        // 会员储值弹窗打开事件
        async onRechargeDialogOpened() {
            this.isMemberRecharge = true;
            // 重新加载账簿列表
            await this.queryCashdeskBook();
        },

        // 会员储值确认事件
        onRechargeConfirm(rechargeData) {
            try {
                this.bookSelectDialogVisible = true;
                this.payableAmount = rechargeData.psmoney;
                this.payableRemark = rechargeData.remark;

                // 添加键盘事件监听并自动聚焦
                this.$nextTick(() => {
                    // 移除所有键盘事件监听器，避免事件冲突
                    document.removeEventListener('keydown', this.handleBookDialogKeyDown);

                    // 设置一个短暂延迟再添加账簿对话框的事件监听器
                    // 这样可以防止打开对话框的Enter键事件被传递到账簿选择界面
                    setTimeout(() => {
                        // 添加账簿对话框的事件监听器
                        document.addEventListener('keydown', this.handleBookDialogKeyDown);

                        // 自动聚焦到第一个账簿输入框
                        if (this.bookList && this.bookList.length > 0) {
                            this.focusBookInput(0);
                        }
                    }, 300); // 300毫秒延迟，防止Enter键事件传递
                });
            } catch (error) {
                this.$message.error('储值失败：' + error.message);
            }
        },

        // 会员储值取消事件
        onRechargeCancel() {
            this.isMemberRecharge = false;
            // 重新加载账簿列表
            this.queryCashdeskBook();
        },

        // 处理储值快捷键
        async handleRechargeShortcut() {
            if (!this.memberInfo.memId) {
                this.$message.warning('请先选择会员卡');
                return;
            }

            // 设置为会员储值模式
            this.isMemberRecharge = true;
            this.isRechargeMode = true;

            // 重新加载账簿列表
            await this.queryCashdeskBook();

            // 准备储值表单数据
            this.rechargeForm.cardNo = this.memberInfo.customerPhoneNumber;
            this.rechargeForm.name = this.memberInfo.customerName;
            this.rechargeForm.storedBalance = this.memberInfo.storedBalance || 0;
            this.rechargeForm.memId = this.memberInfo.memId;
            this.rechargeForm.rechargeType = 0;
            this.rechargeForm.psmoney = '';

            // 打开储值弹窗
            this.rechargeDialogVisible = true;
        },
        // -------------会员卡弹窗-------------
        // 处理会员选择弹窗的键盘事件
        handleMemberDialogKeyDown(event) {
            if (!this.memberSelectDialogVisible) {
                return;
            }
            // 检查是否在输入框中
            const target = event.target;
            const isInputElement = target.tagName === 'INPUT' ||
                target.tagName === 'TEXTAREA' ||
                target.contentEditable === 'true' ||
                target.closest('.el-input') ||
                target.closest('.el-textarea');

            if (isInputElement) {
                // 在输入框中，只处理上下键
                if (event.key === 'ArrowUp' || event.key === 'ArrowDown') {
                    event.preventDefault();
                    this.handleMemberSelection(event.key);
                }
                return;
            }

            // 不在输入框中，处理更多快捷键
            if (event.key === 'ArrowUp' || event.key === 'ArrowDown') {
                event.preventDefault();
                this.handleMemberSelection(event.key);
            } else if (event.key === 'Enter') {
                event.preventDefault();
                this.resetPromotion();
                this.selectCurrentMember();
            } else if (event.key === 'Escape') {
                event.preventDefault();
                this.closeMemberDialog();
            }
        },
        handleMemberCardEnter() {
            // 检查会员卡号是否为空
            if (!this.memberInfo.customerPhoneNumber || this.memberInfo.customerPhoneNumber.trim() === '') {
                this.$message.warning('请输入会员手机号进行查询');
                return;
            }
            this.openMemberSelectDialog();
        },

        // 会员信息（姓名、身份证号）变化处理
        onMemberInfoChange() {
            // 如果会员信息发生变化，且是从下拉选择来的会员，则重置促销方案
            if (this.isMemberFromDropdown) {
                console.log('会员信息发生变化，重置促销方案');

                // 重置会员来源标记
                this.isMemberFromDropdown = false;

                // 重置促销方案到原始单价
                if (this.resetPromotion) {
                    this.resetPromotion(-1, true); // forceResetToOriginal = true
                }

                // 重新计算价格
                this.recalculateCartPrices();
            }
        },
        // 处理会员选择
        handleMemberSelection(key) {
            const memberList = this.filterMemberSelectList();
            if (memberList.length === 0) {
                return;
            }

            if (key === 'ArrowUp') {
                // 向上选择
                if (this.selectedMemberIndex > 0) {
                    this.selectedMemberIndex--;
                } else {
                    this.selectedMemberIndex = memberList.length - 1;
                }
            } else if (key === 'ArrowDown') {
                // 向下选择
                if (this.selectedMemberIndex < memberList.length - 1) {
                    this.selectedMemberIndex++;
                } else {
                    this.selectedMemberIndex = 0;
                }
            }

            // 滚动到选中项
            this.$nextTick(() => {
                this.scrollToSelectedMember();
            });
        },
        // 重新计算购物车中所有商品的价格（当会员状态变化时调用）
        recalculateCartPrices() {
            this.cartItems.forEach(item => {
                // 根据当前数量计算最优价格（考虑限购数量）
                const optimalPrice = this.getOptimalPrice(item, item.quantity);
                item.actualPrice = optimalPrice;
                // 如果没有手动改过单价，则同步changePrice为最优价格
                if (!item.isPriceManuallyChanged) {
                    item.changePrice = optimalPrice;
                }
                item.amount = (item.changePrice || optimalPrice) * item.quantity;

                // 如果允许抹零，对单个商品金额进行抹零处理（保留小数点后一位，不四舍五入）
                if (this.memberInfo.isSmall === 1) {
                    item.amount = Math.round(item.amount * 10) / 10;
                } else if (this.memberInfo.isSmall === 2) {
                    item.amount = Math.floor(item.amount * 10) / 10;
                }
            });
            this.updateTotal();
        },
        // 选择当前会员
        selectCurrentMember() {
            const memberList = this.filterMemberSelectList();
            if (this.selectedMemberIndex >= 0 && this.selectedMemberIndex < memberList.length) {
                this.onMemberSelect(memberList[this.selectedMemberIndex]);
            }
        },
        // 关闭会员选择弹窗
        closeMemberDialog() {
            this.memberSelectDialogVisible = false;
            this.selectedMemberIndex = -1;
            this.isMemberRecharge = false;
            // 重新加载账簿列表
            this.queryCashdeskBook();
        },
        // 滚动到选中的会员
        scrollToSelectedMember() {
            const tableBody = this.$el.querySelector('.el-table__body-wrapper');
            if (tableBody && this.selectedMemberIndex >= 0) {
                const rows = tableBody.querySelectorAll('.el-table__row');
                if (rows[this.selectedMemberIndex]) {
                    rows[this.selectedMemberIndex].scrollIntoView({
                        behavior: 'smooth',
                        block: 'nearest'
                    });
                }
            }
        },
        // 获取会员行的class名称
        getMemberRowClassName({ row, rowIndex }) {
            if (rowIndex === this.selectedMemberIndex) {
                return 'selected-member-row';
            }
            return '';
        },
        // 会员选择弹窗搜索
        onMemberSelectSearch() {
            this.selectedMemberIndex = -1; // 重置选中状态
            this.getMemberList();
        },

        // 会员选择弹窗打开事件
        onMemberDialogOpen() {
            this.isMemberRecharge = false;
            this.$nextTick(() => {
                // 聚焦到表格
                if (this.$refs.memberTable) {
                    this.$refs.memberTable.$el.focus();
                }
            });
        },
        filterMemberSelectList() {
            // 直接返回会员列表，不调用接口
            return this.memberSelectList;
        },
        onMemberSelect(row) {
            // this.memberCardNo = row.cardNo;
            this.memberInfo.customerName = row.name;
            this.memberInfo.customerPhoneNumber = row.phone;
            this.memberInfo.customerIdCard = row.idCard;
            this.memberInfo.cardType = row.cardType;
            this.memberInfo.points = row.points;
            this.memberInfo.registerStore = row.registerStore;
            this.memberInfo.storedBalance = row.storedBalance;
            this.memberInfo.memId = row.memId; // 设置会员ID
            this.memberSelectDialogVisible = false;
            this.selectedMemberIndex = -1; // 重置选中状态
            this.isMemberFromDropdown = true; // 标记会员信息来自下拉选择

            // 会员状态变化时，先重置所有促销方案，恢复到原始单价
            if (this.resetPromotion) {
                console.log('会员状态变化，重置促销方案到原始单价');
                this.resetPromotion(-1, true); // forceResetToOriginal = true
            }

            // 重新计算购物车中所有商品的价格
            this.recalculateCartPrices();
            // 实时参与活动方案
            // this.getRealTimePromotions()
            // 强制刷新购物车表格，确保应收价实时更新
            this.cartItems = [...this.cartItems];

        },
        openMemberSelectDialog() {
            this.memberSelectDialogVisible = true;
            this.selectedMemberIndex = -1; // 重置选中状态
            this.memberSelectSearch = this.memberInfo.customerPhoneNumber; // 设置初始搜索值 

            // 立即搜索匹配的数据
            this.getMemberList();
        },
        // 获取会员列表
        async getMemberList() {
            try {
                const searchKey = this.memberSelectSearch.trim();
                // 检查搜索关键词是否为空
                if (!searchKey) {
                    this.memberSelectList = [];
                    this.selectedMemberIndex = -1;
                    return;
                }
                const res = await this.$http.queryMembermastList({
                    businessId: "",
                    creater: 0,
                    end: 0,
                    // memIdcard: searchKey, // 身份证号搜索
                    // memName: searchKey, // 姓名搜索
                    memPhone: searchKey, // 手机号搜索
                    memState: 1,
                    ormId: 1,
                    page: 1,
                    rows: 1000,
                    start: 0
                });
                if (res && res.status === 200 && res.result && res.result.list) {
                    this.memberSelectList = res.result.list.map(item => ({
                        cardNo: item.cardCode || '',
                        cardType: item.capName || '',
                        name: item.memName || '',
                        phone: item.memPhone || '',
                        idCard: item.memIdcard || '',
                        points: item.pointBalance || 0,
                        registerStore: item.storeName || '',
                        pointBalance: item.pointBalance || 0,
                        storedBalance: item.storedBalance || 0,
                        memId: item.memId || '' // 添加会员ID
                    }));
                    console.log(this.memberSelectList, 'this.memberSelectList');
                    // 默认选择第一条数据
                    if (this.memberSelectList.length > 0) {
                        this.selectedMemberIndex = 0;
                    } else {
                        this.selectedMemberIndex = -1;
                    }
                    // 如果只有一个搜索结果，自动选择该会员
                    if (this.memberSelectList.length === 1 && this.memberInfo.customerPhoneNumber) {
                        this.onMemberSelect(this.memberSelectList[0]);
                    }
                }
            } catch (error) {
                console.error('获取会员列表失败:', error);
                this.$message.error('获取会员列表失败');
            }
        },
        // 加载本地挂单
        async loadHoldOrders() {
            await this.getHoldOrdersFromStorage().then(res => {
                this.holdOrderList = res;
            })
        },
        // 获取本地挂单
        async getHoldOrdersFromStorage() {
            const params = {
                type: "划价台-挂单",
                rows: 1000,
                page: 1
            }
            const res = await this.$http.draftGetList(params);
            if (res.status == 200) {
                return res.result;
            } else {
                return [];
            }
        },
        // F7取单
        async onFetchOrder() {
            await this.loadHoldOrders().then(res => {
                this.holdOrderDialogVisible = true;
                this.selectedHoldOrderIndex = this.holdOrderList.length > 0 ? 0 : -1;
                this.$nextTick(() => {
                    if (this.$refs.holdOrderTable) {
                        this.$refs.holdOrderTable.$el.focus();
                    }
                });
            })
        },        // 还原挂单
        async restoreHoldOrder(order) {
            // 如果购物车有商品，先提醒用户
            if (this.cartItems && this.cartItems.length > 0) {
                try {
                    await this.$confirm('购物车已有商品，取单会覆盖当前购物车内容，是否继续？', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning',
                    });
                } catch (e) {
                    // 用户取消
                    return;
                }
            }

            this.cartItems = JSON.parse(order.jsonContent).cartItems;
            this.memberInfo = JSON.parse(order.jsonContent).memberInfo;
            this.selectedItemIndex = this.cartItems.length > 0 ? 0 : -1;
            this.selectedProduct = this.cartItems[0] || {};
            this.quantityChange = ''; // 重置为默认值1
            this.updateTotal();
            this.holdOrderDialogVisible = false;
            this.$message.success('挂单已还原');
            // 取单后清除该挂单信息
            this.pendingOrderDel(order)
        },
        // ================ 挂单弹窗事件处理 ================
        // 挂单弹窗打开事件
        onHoldOrderDialogOpened() {
            // 弹窗打开后的处理逻辑
            console.log('挂单列表弹窗已打开');
        },
        // 挂单弹窗关闭事件
        onHoldOrderDialogClose() {
            // 弹窗关闭后的处理逻辑
            console.log('挂单列表弹窗已关闭');
        },

        // F6挂单
        onHoldOrder() {
            if (this.cartItems.length === 0) {
                this.$message.warning('购物车为空，无法挂单');
                return;
            }
            this.holdOrderRemark = '';
            this.holdOrderRemarkDialogVisible = true;
            // 聚焦逻辑移到弹窗@opened事件
        },
        // 挂单备注弹窗打开后自动聚焦输入框
        onHoldOrderRemarkDialogOpened() {
            this.$nextTick(() => {
                if (this.$refs.holdOrderRemarkInput && this.$refs.holdOrderRemarkInput.focus) {
                    this.$refs.holdOrderRemarkInput.focus();
                    this.$refs.holdOrderRemarkInput.select && this.$refs.holdOrderRemarkInput.select();
                }
            });
        },
        // 确认挂单
        confirmHoldOrder() {
            const order = {
                cartItems: JSON.parse(JSON.stringify(this.cartItems)),
                memberInfo: JSON.parse(JSON.stringify(this.memberInfo)),
                memberCardNo: this.memberInfo.customerPhoneNumber,
            };
            const parmas = {
                jsonContent: JSON.stringify(order),
                remark: this.holdOrderRemark
            }
            this.pendingOrder(parmas)
            this.holdOrderRemarkDialogVisible = false;
            // 清空购物车和相关信息
            this.cartItems = [];
            this.selectedItemIndex = -1;
            this.selectedProduct = {};
            this.quantityChange = '';
            // 清空会员信息
            // this.memberCardNo = '';
            this.memberInfo = {
                name: '',
                points: '',
                level: '',
                storedBalance: '',
                storeName: '',
                cashier: '',
                salesPerson: this.memberInfo.salesPerson, // 保留销售员信息
                doctor: '',
                pharmacist: '',
                customerName: '',
                customerPhoneNumber: '',
                customerIdCard: '',
                cardType: '',
                memId: '',
                registerStore: '',
                isSmall: 0,
            };
            this.isMemberFromDropdown = false; // 重置会员信息来源标记，允许重新输入
            this.updateTotal();
        },
        // ----------------商品选择弹窗----------------
        // 商品搜索
        handleProductSearch() {
            // 检查搜索关键词是否为空
            if (!this.searchKey || this.searchKey.trim() === '') {
                this.$message.warning('请输入商品编号或名称进行搜索');
                return;
            }
            // 如果是底部输入框触发，则弹窗并同步内容
            if (!this.productSelectDialogVisible) {
                this.productSelectDialogVisible = true;
                this.productSelectSearch = this.searchKey;
                // 延迟执行搜索，确保弹窗已打开
                this.$nextTick(() => {
                    this.getProductList(this.searchKey);
                });
                return;
            }

            // 弹窗内的搜索
            const keyword = this.productSelectSearch;

            // 检查关键词是否为空
            if (!keyword || keyword.trim() === '') {
                this.$message.warning('请输入商品编号或名称进行搜索');
                return;
            }

            // 清除上一次的定时器
            if (this.productSearchTimer) {
                clearTimeout(this.productSearchTimer);
            }
            // 设置新的定时器，500ms后执行搜索
            this.productSearchTimer = setTimeout(() => {
                this.getProductList(keyword);
            }, 500);
        },
        async getProductList(keyword = '') {
            try {
                // 检查关键词是否为空
                if (!keyword || keyword.trim() === '') {
                    this.productSelectList = [];
                    this.selectedProductIndex2 = -1;
                    return;
                }

                const res = await this.$http.getRetailBgmInfo({
                    // barcode: keyword,
                    bgmName: keyword,
                    curDate: this.curDate,
                    curTime: this.curTime,
                    day: this.day,
                    storeId: this.storeId,
                    week: this.week,
                    isZero:this.isZero
                    // isZy:1//是否中药
                });
                if (res && res.status === 200 && res.result && Array.isArray(res.result)) {
                    this.productSelectList = res.result.map(item => ({
                        barcode: item.barcode,
                        bgmName: item.bgmName,
                        spec: item.spec,
                        price: item.price,
                        batchno: item.batchno,
                        manufacturer: item.manufacturer,
                        prodate: item.prodate,
                        expidate: item.expidate,
                        bgiPretype: item.bgiPretype,
                        bgiType: item.bgiType,
                        spPrice: item.spPrice,
                        memberPrice: item.memberPrice,
                        bgmId: item.bgmId,
                        bgiPerholder: item.bgiPerholder,
                        bgiAppnumber: item.bgiAppnumber,
                        num: item.num,

                    }));

                    // 默认选中第一条商品
                    if (this.productSelectList.length > 0) {
                        this.selectedProductIndex2 = 0;
                        // 滚动到第一条商品
                        this.$nextTick(() => {
                            this.scrollToSelectedProduct();
                        });
                    } else {
                        this.selectedProductIndex2 = -1;
                    }

                    // 只匹配到一个商品时，自动回显并关闭弹窗
                    if (this.productSelectList.length === 1) {
                        this.selectedProduct = { ...this.productSelectList[0], quantity: 1 };

                        this.productSelectDialogVisible = false;

                        // this.addToCart(this.selectedProduct);
                        this.onProductSelect(this.selectedProduct)
                        // 选择商品后聚焦到数量输入框
                        this.$nextTick(() => {
                            setTimeout(() => {
                                this.focusQuantityInput();
                            }, 100);
                        });
                    }
                } else {
                    this.productSelectList = [];
                    this.selectedProductIndex2 = -1;
                }
            } catch (error) {
                this.$message.error('获取商品列表失败');
                this.productSelectList = [];
                this.selectedProductIndex2 = -1;
            }
        },
        // 处理商品选择弹窗的键盘事件
        handleProductDialogKeyDown(event) {
            if (!this.productSelectDialogVisible) {
                return;
            }
            // 不在输入框中，处理更多快捷键
            if (event.key === 'ArrowUp' || event.key === 'ArrowDown') {

                event.preventDefault();
                this.handleProductSelection(event.key);
            } else if (event.key === 'Enter') {
                event.preventDefault();
                this.selectCurrentProduct();
                // 聚焦到数量输入框
                this.focusQuantityInput()

            } else if (event.key === 'Escape') {
                event.preventDefault();
                this.closeProductDialog({ focusInput: true });
            }
        },
        // 处理商品选择
        handleProductSelection(key) {
            if (this.productSelectList.length === 0) {
                return;
            }

            // 先清除Element UI的当前行高亮
            if (this.$refs.productTable) {
                this.$refs.productTable.setCurrentRow(null);
            }

            if (key === 'ArrowUp') {
                // 向上选择
                if (this.selectedProductIndex2 > 0) {
                    this.selectedProductIndex2--;
                } else {
                    this.selectedProductIndex2 = this.productSelectList.length - 1;
                }
            } else if (key === 'ArrowDown') {
                // 向下选择
                if (this.selectedProductIndex2 < this.productSelectList.length - 1) {
                    this.selectedProductIndex2++;
                } else {
                    this.selectedProductIndex2 = 0;
                }
            }

            // 滚动到选中项并设置当前行
            this.$nextTick(() => {
                this.scrollToSelectedProduct();
                // 设置Element UI的当前行高亮
                if (this.$refs.productTable && this.selectedProductIndex2 >= 0) {
                    this.$refs.productTable.setCurrentRow(this.productSelectList[this.selectedProductIndex2]);
                }
            });
        },

        // 选择当前商品
        selectCurrentProduct() {

            if (this.selectedProductIndex2 >= 0 && this.selectedProductIndex2 < this.productSelectList.length) {
                this.onProductSelect(this.productSelectList[this.selectedProductIndex2]);
            }
        },

        // 关闭商品选择弹窗
        closeProductDialog(options = {}) {
            // 关闭对话框会自动调用onProductDialogClose
            this.productSelectDialogVisible = false;
            this.selectedProductIndex2 = -1;
            if (options.focusInput) {
                this.$nextTick(() => {
                    if (this.$refs.productSearchInput) {
                        const inputElement = this.$refs.productSearchInput.$el.querySelector('input');
                        if (inputElement) {
                            inputElement.focus();
                            inputElement.select();
                        }
                    }
                });
            }
        },

        // 滚动到选中的商品
        scrollToSelectedProduct() {
            this.$nextTick(() => {
                // 查找商品选择弹窗中的表格
                const productTable = document.querySelector('.el-dialog__wrapper:not([style*="display: none"]) #productTable');
                if (!productTable) return;

                const tableBody = productTable.querySelector('.el-table__body-wrapper');
                if (tableBody && this.selectedProductIndex2 >= 0) {
                    const rows = tableBody.querySelectorAll('.el-table__row');
                    if (rows[this.selectedProductIndex2]) {
                        // 计算目标行的位置
                        const targetRow = rows[this.selectedProductIndex2];
                        const containerHeight = tableBody.clientHeight;
                        const rowTop = targetRow.offsetTop;
                        const rowHeight = targetRow.offsetHeight;

                        // 计算滚动位置，确保选中行在可视区域中间
                        const scrollTop = rowTop - (containerHeight / 2) + (rowHeight / 2);

                        // 平滑滚动到目标位置
                        tableBody.scrollTo({
                            top: Math.max(0, scrollTop),
                            behavior: 'smooth'
                        });
                    }
                }
            });
        },
        // 获取商品行的class名称
        getProductRowClassName({ row, rowIndex }) {
            if (rowIndex === this.selectedProductIndex2) {
                return 'selected-product-row';
            }
            return '';
        },
        // 商品选择弹窗关闭事件
        onProductDialogClose() {
            // 移除键盘事件监听
            document.removeEventListener('keydown', this.handleProductDialogKeyDown);
            // 清除选中状态
            this.selectedProductIndex2 = -1;
            if (this.$refs.productTable) {
                this.$refs.productTable.setCurrentRow(null);
            }

        },

        // 打开促销方案选择弹窗
        async openPromotionSelectDialog() {
            // 检查购物车是否有商品
            if (this.cartItems.length === 0) {
                this.$message.warning('请先添加商品到购物车');
                return;
            }
            console.log(this.cartItems, 'this.cartItems');

            // 获取促销方案列表
            try {
                const res = await this.$http.checkBgmAblePlan({
                    bgmList: this.cartItems.map(item => ({
                        bgmId: item.bgmId,
                        num: item.quantity,
                        recPrice: item.amount,
                        sellPrice: item.price * item.quantity
                    })),
                    curDate: this.curDate,
                    curTime: this.curTime,
                    day: this.day,
                    memId: this.memberInfo.memId ? this.memberInfo.memId : '',
                    storeId: this.storeId,
                    week: this.week
                })

                if (res && res.status === 200 && res.result) {
                    console.log(res, 'res');

                    if ((!res.result.clList || res.result.clList.length === 0) &&
                        (!res.result.mzList || res.result.mzList.length === 0)) {
                        this.$message.info('当前商品暂无可用促销方案');
                        return;
                    }
                    // 合并所有类型的促销方案
                    let allPromotions = [];
                    // 处理超量促销
                    if (res.result.clList && res.result.clList.length > 0) {
                        allPromotions = allPromotions.concat(res.result.clList.map(item => ({
                            ...item,
                            sellType: 31 // 超量促销
                        })));
                    }
                    // 处理满赠促销
                    if (res.result.mzList && res.result.mzList.length > 0) {
                        allPromotions = allPromotions.concat(res.result.mzList.map(item => ({
                            ...item,
                            sellType: 32 // 满赠促销
                        })));
                        // 处理满赠促销的赠品列表
                        this.giftList = [];
                        this.giftYhqList = [];
                        res.result.mzList.forEach(plan => {
                            if (plan.mzGiftType == 1) {
                                // 赠品
                                if (plan.giftBgmList && Array.isArray(plan.giftBgmList)) {
                                    plan.giftBgmList.forEach(gift => {
                                        this.giftList.push({
                                            ...gift,
                                            planId: plan.planId,
                                            planName: plan.planName,
                                            stageDesc: `满${plan.mzConBgmNum || 0}件赠送${plan.mzGiftNum || 0}件`,
                                            giftNum: gift.giftNum || 0,
                                            retailPrice: 0
                                        });
                                    });

                                }


                            }
                            if (plan.mzGiftType == 2) {
                                // 优惠券
                                if (plan.giftYhqList && Array.isArray(plan.giftYhqList)) {
                                    plan.giftYhqList.forEach(gift => {
                                        this.giftYhqList.push({
                                            ...gift,
                                            yhqId: gift.yhqId,
                                            yhqName: gift.yhqName,
                                            yhqDesc: gift.yhqDesc,
                                            limitDay: gift.limitDay,
                                            remark: gift.remark,
                                            inputNum: 0,

                                        });
                                    });
                                }
                            }
                        });
                    }
                    // 处理调价促销（积分）
                    if (res.result.tjPoint && res.result.tjPoint.length > 0) {
                        allPromotions = allPromotions.concat(res.result.tjPoint.map(item => ({
                            ...item,
                            sellType: 41 // 调价
                        })));
                    }
                    // 处理调价促销（价格）
                    if (res.result.tjPrice && res.result.tjPrice.length > 0) {
                        allPromotions = allPromotions.concat(res.result.tjPrice.map(item => ({
                            ...item,
                            sellType: 42 // 调价
                        })));
                    }
                    this.promotionSelectList = allPromotions;
                    this.selectedPromotions = [];
                    this.promotionSelectDialogVisible = true;
                    // 回显复选框
                    this.onPromotionDialogOpened()

                } else {
                    this.$message.error('获取促销方案失败');
                }
            } catch (error) {
                this.$message.error('获取促销方案列表失败');
                this.promotionSelectList = [];
            }
            this.promotionSelectSearch = '';
        },
        async openPromotionSelectDialogII() {
            // 检查购物车是否有商品
            if (this.cartItems.length === 0) {
                this.$message.warning('请先添加商品到购物车');
                return;
            }
            // 获取促销方案列表
            try {
                const res = await this.$http.sellPlanCheckBgmPlan({
                    batchno: this.selectedProduct.batchno,
                    bgmId: this.selectedProduct.bgmId,
                    curDate: this.curDate,
                    curTime: this.curTime,
                    day: this.day,
                    memId: this.memberInfo.memId ? this.memberInfo.memId : '',
                    storeId: this.storeId,
                    week: this.week
                });

                if (res && res.status === 200 && res.result) {
                    if (res.result.clList == null && res.result.mzList == null && res.result.tjPoint == null && res.result.tjPrice == null) {
                        this.$message.info('当前商品暂无可用促销方案');
                        return;
                    }

                    // 合并所有类型的促销方案
                    let allPromotions = [];

                    // 处理超量促销
                    if (res.result.clList && res.result.clList.length > 0) {
                        allPromotions = allPromotions.concat(res.result.clList.map(item => ({
                            ...item,
                            sellType: 31 // 超量促销
                        })));
                    }

                    // 处理满赠促销
                    if (res.result.mzList && res.result.mzList.length > 0) {
                        allPromotions = allPromotions.concat(res.result.mzList.map(item => ({
                            ...item,
                            sellType: 32 // 满赠促销
                        })));


                        // 处理满赠促销的赠品列表
                        this.giftList = [];
                        res.result.mzList.forEach(plan => {
                            if (plan.giftBgmList && Array.isArray(plan.giftBgmList)) {
                                plan.giftBgmList.forEach(gift => {
                                    this.giftList.push({
                                        ...gift,
                                        planId: plan.planId,
                                        planName: plan.planName,
                                        stageDesc: `满${plan.mzConBgmNum || 0}件赠送${plan.mzGiftNum || 0}件`,
                                        giftNum: gift.giftNum || 0,
                                    });
                                });
                            }
                        });
                        console.log(this.giftList, 'this.giftList');
                    }

                    // 处理调价促销（积分）
                    if (res.result.tjPoint && res.result.tjPoint.length > 0) {
                        allPromotions = allPromotions.concat(res.result.tjPoint.map(item => ({
                            ...item,
                            sellType: 41 // 调价
                        })));
                        // if (!res.result.tjPrice && !res.result.tjPrice.length) { }
                    }

                    // 处理调价促销（价格）
                    if (res.result.tjPrice && res.result.tjPrice.length > 0) {
                        allPromotions = allPromotions.concat(res.result.tjPrice.map(item => ({
                            ...item,
                            sellType: 42 // 调价
                        })));

                    }

                    this.promotionSelectList = allPromotions;
                    this.promotionSelectDialogVisibleII = true;
                    // 只有在没有已选择的促销方案时才清空选择
                    if (!this.selectedPromotions || this.selectedPromotions.length === 0) {
                        this.selectedPromotions = [];
                    }
                } else {
                    this.$message.error('获取促销方案失败');
                }
            } catch (error) {
                this.$message.error('获取促销方案列表失败');
                this.promotionSelectList = [];
            }
            this.promotionSelectSearch = '';
        },
        // ------------------收款台-----------
        // 收款台选择确认事件
        async onDeskSelectConfirm(selectedDesk) {
            this.memberInfo.deskCode = selectedDesk.deskCode;
            this.memberInfo.isSmall = selectedDesk.isSmall || 0;
            this.memberInfo.deskId = selectedDesk.deskId;
            this.deskSelected = true; // 标记为已选择
            // 聚焦到销售员选择框
            this.$nextTick(() => {
                if (this.$refs.salesPersonSelect) {
                    this.$refs.salesPersonSelect.focus();
                }
            });
            // 获取账簿信息
            await this.queryCashdeskBook();
            this.$message.success(`已选择收款台：${selectedDesk.deskCode}`);
        },

        // 收款台选择取消事件
        onDeskSelectCancel() {
            this.$alert('未选择收款台，将退出当前页面。', '提示', {
                confirmButtonText: '确定',
                callback: () => {
                    this.onExit();
                }
            });
        },
        // 获取账簿信息
        async queryCashdeskBook() {
            const res = await this.$http.queryCashdeskBook({
                ids: [this.memberInfo.deskId]
            })
            if (res && res.status === 200 && res.result) {
                this.bookList = res.result
                    .filter(item => {
                        // 如果是会员充值场景，过滤掉payType为2和5的数据
                        if (this.isMemberRecharge) {
                            return item.payType != '2' && item.payType != '5';
                        }
                        return true;
                    })
                    .map(item => ({
                        name: item.abookName,
                        value: item.abookId,
                        code: item.code || item.abookCode || item.abookId,
                        inputMoney: 0, // 新增字段，初始化为0
                        payType: item.payType, //(0:其他、1:现金、2:会员、3:微信、4:支付宝、5:医保)
                        ...item
                    }));
                console.log(this.bookList, 'this.bookList');

            }
        },
        //--------------- 修改单价弹窗---------------
        onPriceEditDialogClose() {
            this.selectedCartItem = null;
            this.focusCartTable();
        },
        // 单价弹窗打开事件
        onPriceEditDialogOpened() {
            // 组件内部已处理聚焦逻辑，这里可以添加其他需要的逻辑
        },
        async onPriceEditConfirm({ price, credentials }) {
            if (this.selectedItemIndex !== -1 && this.cartItems[this.selectedItemIndex]) {
                const newPrice = parseFloat(price);

                try {
                    // 验证账号密码
                    const sendInfo = {
                        opmAccount: credentials.username,
                        passWord: credentials.password,
                    };
                    const res = await this.$http.reviewVerification(sendInfo);

                    if (res.status == 200) {
                        this.opmStore = res.result.opmStore;
                        if (this.opmStore == 1) {
                            // 允许修改单价
                            this.cartItems[this.selectedItemIndex].changePrice = newPrice;
                            this.cartItems[this.selectedItemIndex].isPriceManuallyChanged = true; // 标记为手动修改
                            this.updateItemPrice(this.selectedItemIndex);
                            this.$message.success('单价修改成功');
                            this.priceEditDialogVisible = false;
                        } else {
                            // 不允许修改单价
                            this.$message.error('无权限修改单价');
                        }
                    } else {
                        this.$message.error('账号密码验证失败');
                    }
                } catch (error) {
                    console.error('验证失败:', error);
                    this.$message.error('验证失败，请重试');
                }
            }
        },
        // ---------------行样式-------------------
        // 获取行的class名称
        getRowClassName({ row, rowIndex }) {
            // 确保selectedItemIndex是有效的索引值
            const isValidIndex = this.selectedItemIndex >= 0 &&
                this.selectedItemIndex < this.cartItems.length;

            // 只有当索引有效且匹配当前行时才返回选中样式
            return (isValidIndex && rowIndex === this.selectedItemIndex) ? 'selected-row' : '';
        },
        // 选择表格行
        selectRow(row, column, event) {
            const index = this.cartItems.indexOf(row);
            if (index !== -1) {
                this.selectedItemIndex = index;
                // 重置列索引为销售员列
                this.selectedColumnIndex = 0;
                // 同步更新商品选择区域的信息
                this.syncSelectedItemToProductArea();
                // 聚焦到购物车表格
                this.focusCartTable();
            }
        },
        // -----------------封装的组件内容-------------
        onQuantityEditDialogClose() {
            this.quantityEditDialogVisible = false;
            this.selectedCartItem = null;
            this.focusCartTable();
        },
        onQuantityEditConfirm(data) {
            if (this.selectedItemIndex !== -1 && this.cartItems[this.selectedItemIndex]) {
                const quantity = data.quantity;
                console.log('onQuantityEditConfirm');

                // 更新商品数量
                this.cartItems[this.selectedItemIndex].quantity = quantity;
                this.selectedCartItem.quantity = quantity;

                // 重新计算最优价格（考虑限购数量）
                const item = this.cartItems[this.selectedItemIndex];
                item.actualPrice = this.getOptimalPrice(item, quantity);
                if (item.isDiscounted) {
                    this.resetPromotion();
                }
                // 如果没有手动修改过价格，则更新显示价格
                if (!item.isPriceManuallyChanged) {
                    item.changePrice = item.actualPrice;

                }

                // 计算金额，考虑限购数量
                if (item.isLimitedQuantity && quantity > item.limitedQuantity) {
                    // 如果超出限购数量，分别计算限购部分和超出部分的金额
                    const limitedPartAmount = item.limitedQuantity * item.changePrice;
                    const extraPartAmount = (quantity - item.limitedQuantity) * item.extraPrice;
                    item.amount = limitedPartAmount + extraPartAmount;

                    // 添加限购信息到商品，方便显示
                    item.limitInfo = this.memberInfo.customerPhoneNumber || this.memberInfo.memId ?
                        `限购${item.limitedQuantity}件，超出按会员价` :
                        `限购${item.limitedQuantity}件，超出按原价`;

                    console.log('商品金额计算 - 限购部分:', limitedPartAmount, '超出部分:', extraPartAmount, '总金额:', item.amount);
                } else {
                    // 未超出限购数量，正常计算金额
                    item.amount = item.changePrice * quantity;

                    // 清除限购信息
                    item.limitInfo = '';
                }

                // 如果允许抹零，对单个商品金额进行抹零处理
                if (this.memberInfo.isSmall === 1) {
                    item.amount = Math.round(item.amount * 10) / 10;
                } else if (this.memberInfo.isSmall === 2) {
                    item.amount = Math.floor(item.amount * 10) / 10;
                }

                // 更新总计
                this.updateTotal();
            }
            this.quantityEditDialogVisible = false;
            this.focusCartTable();
        },
        // 销售员选择弹窗确认
        onSalesPersonSelectConfirm(data) {
            console.log('onSalesPersonSelectConfirm', data);
            if (this.selectedItemIndex !== -1 && this.cartItems[this.selectedItemIndex]) {
                this.cartItems[this.selectedItemIndex].salesPerson = data.salesPerson;
                this.cartItems[this.selectedItemIndex].salesPersonName = data.salesPersonName;
                this.selectedCartItem.salesPerson = data.salesPerson;
                this.selectedCartItem.salesPersonName = data.salesPersonName;
                // 显示设置成功提醒
                this.$message.success(`销售员设置成功：${data.salesPersonName || '未设置'}`);
            }
            console.log(this.cartItems, 'this.cartItems98888');

            this.salesPersonSelectDialogVisible = false;
            this.focusCartTable();
        },
        // 销售员选择弹窗关闭
        onSalesPersonSelectDialogClose() {
            this.salesPersonSelectDialogVisible = false;
            this.selectedCartItem = null;
            // 聚焦回购物车的逻辑已由组件内部处理
        },
        // 执业药师选择弹窗关闭事件（新组件事件处理）
        onPharmacistSelectDialogClose() {
            // 清空待添加的商品信息
            this.pendingProductForPharmacist = null;
            // 聚焦到商品录入输入框
            this.focusProductSearchInput();
        },
        // 聚焦到商品录入输入框的通用方法
        focusProductSearchInput() {
            this.$nextTick(() => {
                if (this.$refs.productSearchInput) {
                    const inputElement = this.$refs.productSearchInput.$el.querySelector('input');
                    if (inputElement) {
                        inputElement.focus();
                        inputElement.select(); // 选中输入框中的内容
                    }
                }
            });
        },
        // 执业药师选择确认（新组件事件处理）
        onPharmacistSelectConfirm(data) {
            const { pharmacist, pendingProduct } = data;

            // 更新选中的执业药师
            this.memberInfo.pharmacist = pharmacist;

            // 如果有待添加的商品，自动添加到购物车
            if (pendingProduct) {
                this.addToCart(pendingProduct);
                this.pendingProductForPharmacist = null;
                this.$message.success('执业药师已选择，商品已添加到购物车');
            } else {
                this.$message.success('执业药师已选择');
            }

            // 聚焦到商品录入输入框
            this.focusProductSearchInput();
        },
        onSalesPersonSelectDialogOpened() { },
        onQuantityEditDialogOpened() { },
        onPharmacistSelectDialogOpened() { },
        onChangePasswordDialogOpened() { },
        onChangePasswordDialogClose() { },
        // 修改密码确认（新组件事件处理）
        async onChangePasswordConfirm(passwordData) {
            try {
                // 构建修改密码的参数
                const params = {
                    memId: this.memberInfo.memId, // 会员ID
                    newPwd: passwordData.newPassword, // 新密码
                    oldPwd: passwordData.oldPassword, // 原密码
                };

                // 调用修改密码接口
                const res = await this.$http.updatePassword(params);

                if (res && res.status === 200) {
                    this.$message.success('密码修改成功');
                    this.changePasswordDialogVisible = false;
                } else {
                    this.$message.error(res.message || '密码修改失败');
                }
            } catch (error) {
                console.error('修改密码失败:', error);
                this.$message.error('密码修改失败，请重试');
            }
        },
        // 打开修改密码弹窗
        openChangePasswordDialog() {
            // 检查是否有会员卡信息
            if (!this.memberInfo.customerPhoneNumber && !this.memberInfo.memId) {
                this.$message.warning('请先选择会员卡');
                return;
            }

            // 打开弹窗
            this.changePasswordDialogVisible = true;
        },
    },
};
